import './App.css';
import {createBrowserRouter,Navigate,RouterProvider, useNavigate,} from "react-router-dom"
import Page404 from './Layout/Page404';
import {ConfigContext, ConfigProvider} from '../src/Context/ConfigContext'
import routes, { attendanceRoutes, emailMasterRoutes, letterHeadRoutes, letterMasterRoutes, offerLetterSentForm, otherRoutes, payrollRoutes, policyMasterRoutes, salaryRegisterRoutes, shiftsRoutes, signatoryRoutes, slabRoutes, updateEmaployeeRoutes } from './Routes/Routes'
import AppLayout from './Layout/AppLayout';
import Login from './Pages/LoginPage/Login';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {jwtDecode } from 'jwt-decode';
import { useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import DashboardTemp from './Pages/Dashboard/DashboardTemp';
import ForgotPassword from './Pages/LoginPage/ForgotPassword';
import OtpVerification from './Pages/LoginPage/OtpVerification';
import EmailNotFound from './Pages/LoginPage/EmailNotFound';
import ConfirmPassword from './Pages/LoginPage/ConfirmPassword';
import AdminBasicDetails from "./Pages/AdminProfileDetails/AdminBasicDetails";

const isTokenValid = () => {
  var token = localStorage.getItem("token_erp");
  if (!token) {
    // Token doesn't exist
    return false;
  }

  try {
    const decodedToken = jwtDecode(token);

    if (!decodedToken || !decodedToken.exp) {
      // Token is not valid
      return false;
    }

    // Check if the token is expired
    const currentTime = Math.floor(Date.now() / 1000);

    if (decodedToken.exp < currentTime) {
      // Token is expired
      return false;
    }

    // Token is valid and not expired
    return true;
  } catch (error) {
    console.error('Error while validating token:', error);
    return false;
  }
};

// function App() {
// const [accessibleRoutes,setAccessibleRoutes]=useState([]);
// // const [apiURL, setAPIURL] = useState("http://143.110.190.50:3188/");
// //  const [apiURL, setAPIURL] = useState("http://localhost:4000/");
// const [apiURL, setAPIURL] = useState("http://143.110.190.50:4000/");
// const [apiHeaderJSON, setHeaderJSON] = useState({ token: localStorage.getItem("token_erp"), "Content-Type": "application/json", company_id: localStorage.getItem("company_id_erp"), user_id: localStorage.getItem("user_id_erp"), });

// const findMatchingRoutes = (response, routes) => {
//     const matchedRoutes = [];
  
//     const checkPathMatch = (modules, routes) => {
//       for (const module of modules) {
//         if (module.path) {
//           const match = routes.find((route) => route.path.includes(module.path));
//           if (match) {
//             matchedRoutes.push(match);
//           }
//         }
  
//         // Recursively check for sub_modules
//         if (module.sub_module) {
//           checkPathMatch(module.sub_module, routes);
//         }
//       }
//     };
  
//     checkPathMatch(response, routes);
  
//     return matchedRoutes;
//   };
  
//   const getList = useCallback(() => {
//     const headers = apiHeaderJSON;
//     axios
//       .get(`${apiURL}Employees/GetHeaderPermissionList`, {
//         params: {},
//         headers,
//       })
//       .then((response) => {
//         let data = response.data;
//         console.log(data);
//         if (response.data.success === true) {
//           const result= data?.result;
//           const matchedRoutes = findMatchingRoutes(result, routes);
//           console.log("matchedRoutes ===>",matchedRoutes);
//           setAccessibleRoutes(matchedRoutes || []);

//         } else {
//           console.error("Error fetching list");
//         }
//       })
//       .catch(function (error) {
//         console.log("error", error);
//       });
//   },[]);

//   useEffect(() => {
//     getList();
//   }, []);
//   var mRoutes = [];
//   if(isTokenValid()){
//     mRoutes = [
//       {
//         element: <AppLayout />,
//         errorElement: <Page404 />,
//         children: accessibleRoutes 
//       }
//     ];
//   } else {
//     mRoutes = [
//       { path: '/Login', element: <Login /> },
//       { path: '/', element: <Login /> },
//     ];
//   }
//   const router = createBrowserRouter(mRoutes);

//   return (
//     <ConfigProvider>
//       <RouterProvider router={router} />
//       <ToastContainer />
//     </ConfigProvider>
//   );
// }
function App() {
  // const navigate=useNavigate();
  const [accessibleRoutes, setAccessibleRoutes] = useState([]);
  const [loading, setLoading] = useState(false);
    // const [apiURL, setAPIURL] = useState("http://143.110.190.50:3188/");
  // const [apiURL, setAPIURL] = useState("http://143.110.190.50:4006/");
  // const [apiURL, setAPIURL] = useState("http://localhost:4006/");
  const [apiURL, setAPIURL] = useState("https://erpapi.abstarthr.in/");
  // const [apiURL, setAPIURL] = useState("https://uaterpapi.abstarthr.in/");
  // user_id and company_id is replace with x-user-id and x-company-id because the 
  // browser or backend server  is removing user_id and company_id auto.
  const [apiHeaderJSON, setHeaderJSON] = useState({
    token: localStorage.getItem("token_erp"),
    "Content-Type": "application/json",
    "x-company-id": localStorage.getItem("company_id_erp"),
    "x-user-id": localStorage.getItem("user_id_erp"),
  });

  const findMatchingRoutes = (response, routes) => {
    const matchedRoutes = [];
    const checkPathMatch = (modules, routes) => {
      for (const module of modules) {
        if (module.path) {
          const match = routes.find((route) => {
            return route.path.includes(module.path)
          });
          if (match) {
            matchedRoutes.push(match);
          }
        }

        // Recursively check for sub_modules
        if (module.sub_module) {
          // console.log("module.sub_module",module.sub_module)
          checkPathMatch(module.sub_module, routes);
        }
      }
    };

    checkPathMatch(response, routes);

    return matchedRoutes;
  };
  const handleLogout = () => {
    localStorage.removeItem("token_erp");
    localStorage.removeItem("user_id_erp");
    localStorage.removeItem("company_id_erp");
    window.location.href = '/';
  };
  const getList = useCallback(() => {
    const headers = apiHeaderJSON;
    setLoading(true);
    axios
      .get(`${apiURL}Employees/GetHeaderPermissionList`, {
        params: {},
        headers,
      })
      .then((response) => {
        let data = response.data;
        // console.log(data);
        let matchedRoutes=[];
        if (response.data.success === true) {
          const result = data?.result;
          // console.log("result",result);
           matchedRoutes = findMatchingRoutes(result, routes);
          const matchedRoute = result?.find((route) => {
            return route.path.includes("/");
          });
          if(!matchedRoute){
            matchedRoutes.unshift({ path: "/", element: <DashboardTemp /> },);
          }
          // console.log("matchedRoutes",matchedRoutes);
          for (const path of otherRoutes) {
            if (path) {
              const match = matchedRoutes.find((route) => {
                return route.path.includes(path)
              });
              if (match && path==="LetterHeadList") {
                matchedRoutes.push(...letterHeadRoutes);
              }
              else if (match && path==="LetterList") {
                matchedRoutes.push(...letterMasterRoutes);
              }
              else if (match && path==="CandidateDetailsList") {
                matchedRoutes.push(...updateEmaployeeRoutes);
              }
              else if (match && path==="SignatoryMaster") {
                matchedRoutes.push(...signatoryRoutes);
              }
              else if (match && path==="PolicyMaster") {
                matchedRoutes.push(...policyMasterRoutes);
              }
              else if (match && path==="EmailTemplateList") {
                matchedRoutes.push(...emailMasterRoutes);
              }
              else if (match && path==="PayrollHeadMaster") {
                matchedRoutes.push(...payrollRoutes);
              }
              else if (match && path==="StatutorySlabMaster") {
                matchedRoutes.push(...slabRoutes);
              }
              else if (match && path==="ShifteList") {
                matchedRoutes.push(...shiftsRoutes);
              }
              else if (match && path==="AttendenceRegularization") {
                matchedRoutes.push(...attendanceRoutes);
              }
              else if (match && path==="SalaryReport") {
                matchedRoutes.push(...salaryRegisterRoutes);
              }
              else if (match && path==="GuestEmployee") {
                matchedRoutes.push(...offerLetterSentForm);
              }
            }
          }
          matchedRoutes.push({ path: "*", element: <Page404/> });
          matchedRoutes.push({ path: "AdminBasicDetails", element: <AdminBasicDetails/> });
          // console.log("matchedRoutes ===>", matchedRoutes);
          setAccessibleRoutes(matchedRoutes || []);
        } else {
          console.error("Error fetching list");
          matchedRoutes.push({ path: "*", element: <Page404/> });
          setAccessibleRoutes(matchedRoutes || []);
          // if(response.data.message==="Invalid Header" && !localStorage.getItem("token_erp") || !localStorage.getItem("user_id_erp") || !localStorage.getItem("company_id_erp")){
          //   handleLogout();
          // }
        }
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        console.log("error", error);
      });
  }, [apiHeaderJSON, apiURL]);

  useEffect(() => {
    if(isTokenValid()){
        getList();
    }
    else{
      if(!localStorage.getItem("reset") && !localStorage.getItem("token_erp")){
        localStorage.setItem("reset",true);
        console.log("entered")
          handleLogout();
      }
    }
  }, []);
// console.log(`isTokenValid() ==== accessibleRoutes.length === 0`,isTokenValid(),"===>",accessibleRoutes.length === 0)
  if (isTokenValid() && accessibleRoutes.length === 0) {
    // While fetching or if no routes are accessible
    return <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
              <div className="text-center">
                  <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                  </div>
              </div>
            </div>;
  }

  const mRoutes = isTokenValid()
    ? [
        {
          element: <AppLayout />,
          errorElement: <Page404 />,
          ErrorBoundary: <Page404 />,
          children: accessibleRoutes,
        },
      ]
    : [
        { path: '/Login', element: <Login /> },
        { path: "/ForgotPassword", element: <ForgotPassword /> },
        { path: "/OtpVerification", element: <OtpVerification /> },
        { path: "/EmailNotFound", element: <EmailNotFound /> },
        { path: "/ConfirmPassword/:employee_id", element: <ConfirmPassword /> },
        { path: '/', element: <Login /> },
        { path: "*", element: <Navigate to="/" replace />  },
      ];

  const router = createBrowserRouter(mRoutes);

  return (
    <ConfigProvider>
      <RouterProvider router={router} />
      <ToastContainer />
    </ConfigProvider>
  );
}

export default App;
